import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withApollo } from 'react-apollo';

import LogoutItem from '../../components/userMenu/LogoutItem';
import { logout } from '../../../actions/user';

export default compose(
    withApollo,
    connect(
        null,
        (dispatch, ownProps) => ({
            logout: () => {
                dispatch(logout());
                setTimeout(() => {
                    ownProps.client.resetStore();
                }, 0);
            },
        }),
    ),
)(LogoutItem);
